import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import SearchIcon from '@material-ui/icons/Search';
import { fade } from '@material-ui/core/styles/colorManipulator';

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import api from '../api/backend'
import moment from 'moment'

import video1 from '../assets/img/video1.png'
import video2 from '../assets/img/video2.png'

const styles = theme => ({
    appBar: {
        position: 'relative',
    },
    icon: {
        marginRight: theme.spacing.unit * 2,
    },
    heroUnit: {
        // backgroundColor: theme.palette.background.paper,
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: 1100,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    cardMedia: {
        paddingTop: '56.25%', // 16:9
    },
    cardContent: {
        flexGrow: 1,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class AllCoursePage extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { courses: [] }
    }

    getCourses = () => {
        api.getCourses().then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ courses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    findCourse = () => {
        const { term } = this.state
        api.searchCourse(term).then(([response, json]) => {
            if (response.status === 200) {
                console.log(json)
                this.setState({ courses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สทั้งหมดได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    getMyCourse = () => {
        api.getMyCourse().then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ myCourses: json })
            } else {
                console.error(`ไม่สามารถรับค่าจากคอร์สของฉันได้`)
            }
        }).catch(() => {
            console.error('ไม่สามารถเชื่อมต่อ service ได้')
        })
    }

    checkMyCourse = (id) => {
        const { myCourses } = this.state
        try {
            const index = myCourses.findIndex((i) => i.course.id === parseInt(id, 10))
            if (index > -1) {
                return true
            } else {
                return false
            }
        } catch (error) {
            return false
        }
    }

    componentDidMount() {
        this.getMyCourse()
        this.getCourses()
    }

    render() {
        const { classes } = this.props
        const { courses } = this.state
        return (
            <main style={{ paddingTop: 64 }}>
                {/* Hero unit */}
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            คอร์สเรียน
                        </Typography>
                        <div className={classes.search}>
                            <div className={classes.searchIcon}>
                                <SearchIcon />
                            </div>
                            <Input
                                placeholder="Search…"
                                disableUnderline
                                classes={{
                                    root: classes.inputRoot,
                                    input: classes.inputInput,
                                }}
                                onChange={(event) => { this.setState({ term: event.target.value }) }}
                                onKeyPress={(ev) => {
                                    if (ev.key === 'Enter') {
                                        this.findCourse()
                                        ev.preventDefault()
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>
                <ExpansionPanel defaultExpanded={true}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="headline">ประถมศึกษา ปีที่ 6</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={40}>
                                {courses.filter(e => { return e.subject.level === 'ประถมศึกษา ปีที่ 6' }).map(course => (
                                    <Grid item key={course.course.id} sm={6} md={4} lg={4}>
                                        <Link to={`/course/${course.course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                            <Card className={classes.card}>
                                                <CardActionArea>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar style={{ borderRadius: 0 }} aria-label="Recipe" className={classes.avatar} src={this.checkMyCourse(course.course.id) ? video1 : video2} />
                                                        }
                                                        title={course.course.title}
                                                        subheader={moment(course.course.startDate).format('DD/MM/YYYY')}
                                                    />
                                                    <CardMedia
                                                        className={classes.cardMedia}
                                                        image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.course.id}`}
                                                        title="Image title"
                                                    />
                                                    <CardContent className={classes.cardContent}>
                                                        <Typography style={{ whiteSpace: 'pre-line', height: 100, overflow: 'hidden' }}>
                                                            {course.course.description}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel defaultExpanded={true}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="headline">มัธยมศึกษา ปีที่ 1</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={40}>
                                {courses.filter(e => { return e.subject.level === 'มัธยมศึกษา ปีที่ 1' }).map(course => (
                                    <Grid item key={course.course.id} sm={6} md={4} lg={4}>
                                        <Link to={`/course/${course.course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                            <Card className={classes.card}>
                                                <CardActionArea>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar style={{ borderRadius: 0 }} aria-label="Recipe" className={classes.avatar} src={this.checkMyCourse(course.course.id) ? video1 : video2} />
                                                        }
                                                        title={course.course.title}
                                                        subheader={moment(course.course.startDate).format('DD/MM/YYYY')}
                                                    />
                                                    <CardMedia
                                                        className={classes.cardMedia}
                                                        image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.course.id}`}
                                                        title="Image title"
                                                    />
                                                    <CardContent className={classes.cardContent}>
                                                        <Typography style={{ whiteSpace: 'pre-line', height: 100, overflow: 'hidden' }}>
                                                            {course.course.description}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel defaultExpanded={true}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="headline">มัธยมศึกษา ปีที่ 2</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={40}>
                                {courses.filter(e => { return e.subject.level === 'มัธยมศึกษา ปีที่ 2' }).map(course => (
                                    <Grid item key={course.course.id} sm={6} md={4} lg={4}>
                                        <Link to={`/course/${course.course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                            <Card className={classes.card}>
                                                <CardActionArea>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar style={{ borderRadius: 0 }} aria-label="Recipe" className={classes.avatar} src={this.checkMyCourse(course.course.id) ? video1 : video2} />
                                                        }
                                                        title={course.course.title}
                                                        subheader={moment(course.course.startDate).format('DD/MM/YYYY')}
                                                    />
                                                    <CardMedia
                                                        className={classes.cardMedia}
                                                        image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.course.id}`}
                                                        title="Image title"
                                                    />
                                                    <CardContent className={classes.cardContent}>
                                                        <Typography style={{ whiteSpace: 'pre-line', height: 100, overflow: 'hidden' }}>
                                                            {course.course.description}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel defaultExpanded={true}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="headline">มัธยมศึกษา ปีที่ 3</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={40}>
                                {courses.filter(e => { return e.subject.level === 'มัธยมศึกษา ปีที่ 3' }).map(course => (
                                    <Grid item key={course.course.id} sm={6} md={4} lg={4}>
                                        <Link to={`/course/${course.course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                            <Card className={classes.card}>
                                                <CardActionArea>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar style={{ borderRadius: 0 }} aria-label="Recipe" className={classes.avatar} src={this.checkMyCourse(course.course.id) ? video1 : video2} />
                                                        }
                                                        title={course.course.title}
                                                        subheader={moment(course.course.startDate).format('DD/MM/YYYY')}
                                                    />
                                                    <CardMedia
                                                        className={classes.cardMedia}
                                                        image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.course.id}`}
                                                        title="Image title"
                                                    />
                                                    <CardContent className={classes.cardContent}>
                                                        <Typography style={{ whiteSpace: 'pre-line', height: 100, overflow: 'hidden' }}>
                                                            {course.course.description}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                    <ExpansionPanel defaultExpanded={true}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="headline">มัธยมศึกษา ปีที่ 4</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={40}>
                                {courses.filter(e => { return e.subject.level === 'มัธยมศึกษา ปีที่ 4' }).map(course => (
                                    <Grid item key={course.course.id} sm={6} md={4} lg={4}>
                                        <Link to={`/course/${course.course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                            <Card className={classes.card}>
                                                <CardActionArea>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar style={{ borderRadius: 0 }} aria-label="Recipe" className={classes.avatar} src={this.checkMyCourse(course.course.id) ? video1 : video2} />
                                                        }
                                                        title={course.course.title}
                                                        subheader={moment(course.course.startDate).format('DD/MM/YYYY')}
                                                    />
                                                    <CardMedia
                                                        className={classes.cardMedia}
                                                        image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.course.id}`}
                                                        title="Image title"
                                                    />
                                                    <CardContent className={classes.cardContent}>
                                                        <Typography style={{ whiteSpace: 'pre-line', height: 100, overflow: 'hidden' }}>
                                                            {course.course.description}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel defaultExpanded={true}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="headline">มัธยมศึกษา ปีที่ 5</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={40}>
                                {courses.filter(e => { return e.subject.level === 'มัธยมศึกษา ปีที่ 5' }).map(course => (
                                    <Grid item key={course.course.id} sm={6} md={4} lg={4}>
                                        <Link to={`/course/${course.course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                            <Card className={classes.card}>
                                                <CardActionArea>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar style={{ borderRadius: 0 }} aria-label="Recipe" className={classes.avatar} src={this.checkMyCourse(course.course.id) ? video1 : video2} />
                                                        }
                                                        title={course.course.title}
                                                        subheader={moment(course.course.startDate).format('DD/MM/YYYY')}
                                                    />
                                                    <CardMedia
                                                        className={classes.cardMedia}
                                                        image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.course.id}`}
                                                        title="Image title"
                                                    />
                                                    <CardContent className={classes.cardContent}>
                                                        <Typography style={{ whiteSpace: 'pre-line', height: 100, overflow: 'hidden' }}>
                                                            {course.course.description}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>

                    <ExpansionPanel defaultExpanded={true}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="headline">มัธยมศึกษา ปีที่ 6</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails>
                            <Grid container spacing={40}>
                                {courses.filter(e => { return e.subject.level === 'มัธยมศึกษา ปีที่ 6' }).map(course => (
                                    <Grid item key={course.course.id} sm={6} md={4} lg={4}>
                                        <Link to={`/course/${course.course.id}`} style={{ textDecoration: 'none', color: 'black' }}>
                                            <Card className={classes.card}>
                                                <CardActionArea>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar style={{ borderRadius: 0 }} aria-label="Recipe" className={classes.avatar} src={this.checkMyCourse(course.course.id) ? video1 : video2} />
                                                        }
                                                        title={course.course.title}
                                                        subheader={moment(course.course.startDate).format('DD/MM/YYYY')}
                                                    />
                                                    <CardMedia
                                                        className={classes.cardMedia}
                                                        image={`${process.env.REACT_APP_BAKEND}/api/courses/cover/${course.course.id}`}
                                                        title="Image title"
                                                    />
                                                    <CardContent className={classes.cardContent}>
                                                        <Typography style={{ whiteSpace: 'pre-line', height: 100, overflow: 'hidden' }}>
                                                            {course.course.description}
                                                        </Typography>
                                                    </CardContent>
                                                </CardActionArea>
                                            </Card>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </ExpansionPanelDetails>
                    </ExpansionPanel>


                </div>
            </main>
        );
    }
}

export default withStyles(styles)(AllCoursePage);